import { useSearchParams } from 'react-router-dom';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AuditLogTab } from '@/features/superadmin/AuditLogTab';
import { ClaimsTab } from '@/features/superadmin/ClaimsTab';
import { OverviewTab } from '@/features/superadmin/OverviewTab';
import { PaymentSettingsTab } from '@/features/superadmin/PaymentSettingsTab';
import { TenantsTab } from '@/features/superadmin/TenantsTab';
import { UnverifiedUsersTab } from '@/features/superadmin/UnverifiedUsersTab';

const TABS = [
  { value: 'overview', label: 'Overview', content: <OverviewTab /> },
  { value: 'pharmacies', label: 'Pharmacies', content: <TenantsTab /> },
  { value: 'claims', label: 'Claims', content: <ClaimsTab /> },
  { value: 'payment-settings', label: 'Payment settings', content: <PaymentSettingsTab /> },
  { value: 'audit-log', label: 'Audit log', content: <AuditLogTab /> },
  { value: 'unverified', label: 'Unverified users', content: <UnverifiedUsersTab /> },
];

/**
 * Platform-operator console. Superadmin bypasses tenant scoping everywhere
 * here — see remarks on SuperadminController for why that's safe.
 */
export function SuperadminPage() {
  const [params, setParams] = useSearchParams();
  const active = params.get('tab') ?? 'overview';

  function handleChange(value: string) {
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', value);
      return next;
    });
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-3xl">Platform admin</h1>
        <p className="text-sm text-muted-foreground">Tenant lifecycle, pricing, and subscriptions across every pharmacy.</p>
      </div>

      <Tabs value={active} onValueChange={handleChange}>
        <TabsList className="flex-wrap">
          {TABS.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map((tab) => (
          <TabsContent key={tab.value} value={tab.value}>
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}